import { LogGroup, LogLevel } from "js/core/logger/enums";

export type LoggerTransportEntryData = Object | any[] | null;

class LoggerTransport<LoggerTransportContext, LogEntryContext> {
    protected _context: LoggerTransportContext

    constructor(context: LoggerTransportContext) {
        this._context = context;
    }

    public log(context: LogEntryContext, group: LogGroup, level: LogLevel, message: string, data: LoggerTransportEntryData, error?: Error) {
        throw new Error("Not implemented");
    }

    public dispose() {
    }
}

export default LoggerTransport;
